Vue.filter('notificationDate', function (value) {
  const date = value.split(' ')[0]
  const dates = date.split('/')
  return dates.join('.')
})